export default (name) => `marko-web-${name}-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
